import { Alert, useTheme } from '@simplywallst/ui-core';
import InformationSolid from '@simplywallst/ui-core/icons/InformationSolid';

export const InfoBanner = () => {
  const theme = useTheme();
  return (
    <Alert icon={<InformationSolid fill={theme.color.neutral} />}>
      Tip: For bulk transaction uploads, use the desktop version to import a CSV
      file or paste data into a spreadsheet.
    </Alert>
  );
};
